export default {
  space: 'ows9csc2fuk9',
  accessToken: 'c57b6a0b3d42af3e38b9b7532d57cc51e93cfe20c411c81d7c0057e882f71438'
}


// WEBPACK FOOTER //
// ./src/contentful/contentful_keys.js